import { Skeleton, Stack } from '@mui/material';

export default function VoiceReceptionistDashboardSkeleton(): JSX.Element {
  return (
    <Stack spacing={3} sx={{ p: 3 }}>
      <Skeleton height={44} width="40%" />
      <Skeleton height={32} width="55%" />
      <Skeleton height={56} />
      <Skeleton height={180} variant="rounded" />
      <Skeleton height={280} variant="rounded" />
    </Stack>
  );
}
